var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37321 5.37321 0 12 0C18.6268 0 24 5.37321 24 12C24 18.6268 18.6268 24 12 24C5.37321 24 0 18.6268 0 12ZM2.03571 12C2.03571 17.5018 6.49821 21.9643 12 21.9643C17.5018 21.9643 21.9643 17.5018 21.9643 12C21.9643 6.49821 17.5018 2.03571 12 2.03571C6.49821 2.03571 2.03571 6.49821 2.03571 12ZM16.43 7.5495C16.5478 7.5495 16.6443 7.64592 16.6443 7.76378C16.6443 7.81467 16.6282 7.86557 16.5961 7.90307L13.1112 12.0549L16.5907 16.204C16.6228 16.2441 16.6416 16.2924 16.6416 16.3432C16.6416 16.4638 16.5452 16.5575 16.4273 16.5575L14.6594 16.5495L11.9996 13.3781L9.3398 16.5522L7.56927 16.5602C7.45141 16.5602 7.35498 16.4638 7.35498 16.3459C7.35555 16.295 7.37351 16.2459 7.40587 16.2066L10.8907 12.0575L7.40587 7.90575C7.37373 7.86557 7.35498 7.81735 7.35498 7.76646C7.35498 7.64593 7.45141 7.55218 7.56927 7.55218L9.3398 7.56021L11.9996 10.7316L14.6621 7.55753L16.43 7.5495Z",
    fill: "#F60C36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.538ab4c8.svg";
export { ForwardRef as ReactComponent };